import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';

import { FeaturedEventService } from '../../core/events/featured-event.service';
import { StoreLogo } from '../store-logo/store-logo';
import { AutoScrollRow } from '../auto-scroll-row/auto-scroll-row';

/**
 * The "{Event} Top Stores" logo row — the row the home page leads with.
 *
 * It reads the featured event from `FeaturedEventService`, the same source the header and the BIG
 * SALE banner use, so changing which event is running in admin moves this row on every page that
 * renders it at once. Nothing renders until an event with top stores resolves.
 *
 * The markup and styles live here because this row is currently copy-pasted into five page
 * stylesheets (home, blog category, deals category, deals event, event detail). New usages should
 * take this component; those five are the ones to converge on it next.
 */
@Component({
  selector: 'app-event-top-stores',
  imports: [RouterLink, StoreLogo, AutoScrollRow],
  templateUrl: './event-top-stores.html',
  styleUrl: './event-top-stores.scss',
})
export class EventTopStores {
  private readonly featuredEvent = inject(FeaturedEventService);

  protected readonly section = toSignal(this.featuredEvent.featuredStores(), {
    initialValue: null,
  });
}
